import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const {
  endpoints: {
    account: { tokenRefresh: url },
  },
} = config

export const tokenRefresh = (token) => axios.post(url, { tokenRefresh: token }, { headers: getHeaders(true) })
